<template>
  <div class="modal-overlay" @click.self="close">
    <div class="modal-content">
      <ModalHeader/>
      <v-expansion-panels style="max-height: 85vh; overflow-y: auto;"  v-model="panelState" multiple>

        <FileUploader :user-id="userId"/>
        <ManualInputSection/>
        <ReferenceSection/>
      </v-expansion-panels>
      <ModalFooter @cancel="close()" @continue="filled()"/>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {defineEmits, ref, watch} from 'vue'
import ModalHeader from './ModalHeader.vue'
import FileUploadSection from './FileUploadSection.vue'
import ManualInputSection from './ManualInputSection.vue'
import ReferenceSection from './ReferenceSection.vue'
import ModalFooter from './ModalFooter.vue'
import FileUploader from "../../components/Modals/FileUploader.vue";
const props=defineProps({
  userId: {
    type: Number,
    required: false
  },
})
const emit = defineEmits(['close', 'fileUploaded']);
const filled = () => {
  emit('fileUploaded');
  close();
}
const close = () => {
  emit('close');
};
const panelState = ref([]);
// Watch for changes to the active panel and collapse previous ones
watch(panelState, (newValue) => {
  if (newValue.length > 1) {
    panelState.value = [newValue[newValue.length - 1]]; // Keep only the last panel open
  }
});
</script>

<style scoped>

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 20px;
  width: 600px;
  border-radius: 8px;
  position: relative;
}

.modal {
  border-radius: 12px;
  background-color: rgba(255, 255, 255, 1);
  display: flex;
  max-width: 616px;
  flex-direction: column;
  overflow: hidden;
  justify-content: start;
  padding: 24px;
}

@media (max-width: 991px) {
  .modal {
    padding: 0 20px;
  }
}
</style>